"use strict";

angular.module("vendor")
.controller("ProductViewSequenceFormController", function(
    $scope, $attrs, close, ProductSequenceService, FlashBag, gettextCatalog
) {
    var _this = this;
    var sequenceId = $attrs.sequenceId;

    if (sequenceId) {
        $scope.sequence = ProductSequenceService.get(sequenceId);
    }
    else {
        $scope.sequence = {};
    }

    this.submit = function() {
        this.resetNameValidity();
        $scope.productSequenceForm.$setSubmitted();
        ProductSequenceService.save(
            $scope.sequence
        ).then(
            function(data) {
                _this.close(data.id);
            },
            function(response) {
                if (response.data["name"]) {
                    $scope.productSequenceForm.name.$setValidity("used", false);
                }
                else {
                    FlashBag.apiError(response);
                }
            }
        );
    };

    this.delete = function() {
        ProductSequenceService.delete(
            $scope.sequence.id
        ).$promise.then(function() {
            FlashBag.success(gettextCatalog.getString("Product sequence was deleted successfully"));
            _this.close(null);
        });
    };

    this.resetNameValidity = function() {
        $scope.productSequenceForm.name.$setValidity("used", true);
    };

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/views/sequence/product-view-sequence-form.modal.js
// module id = 894
// module chunks = 0